export const getNextDate = currentDate => {
  return currentDate.clone().add(1, "day")
}
